module.exports = __webpack_public_path__ + "f2583a89b0aa32be623c4bed81e0a7c2.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_4_b.png
// module id = 76
// module chunks = 0